import CarouselCategories from './CarouselCategories';

export default CarouselCategories;
